import React from 'react';

// Inline stroke icons for the editor toolbar. Everything draws with
// currentColor so buttons inherit the theme tokens (including the inverted
// .active state) without extra CSS.

const Svg = ({ children, filled = false }) => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill={filled ? 'currentColor' : 'none'}
        stroke={filled ? 'none' : 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        focusable="false"
    >
        {children}
    </svg>
);

export const UndoIcon = () => (
    <Svg>
        <path d="M9 14 4 9l5-5" />
        <path d="M4 9h10a6 6 0 0 1 0 12h-3" />
    </Svg>
);

export const RedoIcon = () => (
    <Svg>
        <path d="m15 14 5-5-5-5" />
        <path d="M20 9H10a6 6 0 0 0 0 12h-3" transform="translate(20 0) scale(-1 1) translate(-20 0)" />
    </Svg>
);

export const AlignLeftIcon = () => (
    <Svg>
        <path d="M4 6h16M4 12h10M4 18h14" />
    </Svg>
);

export const AlignCenterIcon = () => (
    <Svg>
        <path d="M4 6h16M7 12h10M5 18h14" />
    </Svg>
);

export const AlignRightIcon = () => (
    <Svg>
        <path d="M4 6h16M10 12h10M6 18h14" />
    </Svg>
);

export const AlignJustifyIcon = () => (
    <Svg>
        <path d="M4 6h16M4 12h16M4 18h16" />
    </Svg>
);

export const BulletListIcon = () => (
    <Svg>
        <path d="M9 6h12M9 12h12M9 18h12" />
        <circle cx="4.5" cy="6" r="1" fill="currentColor" stroke="none" />
        <circle cx="4.5" cy="12" r="1" fill="currentColor" stroke="none" />
        <circle cx="4.5" cy="18" r="1" fill="currentColor" stroke="none" />
    </Svg>
);

export const OrderedListIcon = () => (
    <Svg>
        <path d="M10 6h11M10 12h11M10 18h11" />
        <text
            x="3"
            y="8.2"
            fontSize="7"
            fontFamily="'JetBrains Mono', monospace"
            fill="currentColor"
            stroke="none"
        >
            1
        </text>
        <text
            x="3"
            y="20.2"
            fontSize="7"
            fontFamily="'JetBrains Mono', monospace"
            fill="currentColor"
            stroke="none"
        >
            2
        </text>
    </Svg>
);

export const QuoteIcon = () => (
    <Svg filled>
        <path d="M5 16c0-4.4 1.6-7.4 5.4-8.8l.8 1.8c-2 .9-3 2.2-3.2 4H11v6H5v-3zm8 0c0-4.4 1.6-7.4 5.4-8.8l.8 1.8c-2 .9-3 2.2-3.2 4H19v6h-6v-3z" />
    </Svg>
);

export const CodeIcon = () => (
    <Svg>
        <path d="m8 6-5 6 5 6M16 6l5 6-5 6" />
    </Svg>
);

export const CodeBlockIcon = () => (
    <Svg>
        <rect x="3" y="4" width="18" height="16" rx="2" />
        <path d="m7 9 3 3-3 3M12 15h5" />
    </Svg>
);

export const RuleIcon = () => (
    <Svg>
        <path d="M5 6h14M3 12h18M5 18h14" />
    </Svg>
);

export const ImageIcon = () => (
    <Svg>
        <rect x="3" y="4" width="18" height="16" rx="2" />
        <circle cx="8.5" cy="9.5" r="1.5" fill="currentColor" stroke="none" />
        <path d="m21 15-5-5L6 20" />
    </Svg>
);

export const ClearFormatIcon = () => (
    <Svg>
        <path d="M4 5h10M9 5l-2 14" />
        <path d="m15 13 5 5m0-5-5 5" />
    </Svg>
);

export const LinkIcon = () => (
    <Svg>
        <path d="M9.5 14.5a4 4 0 0 0 5.7 0l3.3-3.3a4 4 0 1 0-5.7-5.7l-1.6 1.6" />
        <path d="M14.5 9.5a4 4 0 0 0-5.7 0l-3.3 3.3a4 4 0 1 0 5.7 5.7l1.6-1.6" />
    </Svg>
);

export const HighlightIcon = () => (
    <Svg>
        <path d="m9 15 8.5-8.5a2.1 2.1 0 0 0-3-3L6 12l3 3z" />
        <path d="m6 12-1.5 4.5L3 19h5l1-4" />
    </Svg>
);

export const TableIcon = () => (
    <Svg>
        <rect x="3" y="4" width="18" height="16" rx="1" />
        <path d="M3 9.5h18M3 14.75h18M9 9.5V20M15 9.5V20" />
    </Svg>
);

export const TrashIcon = () => (
    <Svg>
        <path d="M4 7h16M9 7V5h6v2" />
        <path d="m6 7 1 13h10l1-13" />
    </Svg>
);

export const CaptionIcon = () => (
    <Svg>
        <rect x="4" y="4" width="16" height="11" rx="1" />
        <path d="M7 19h10" />
    </Svg>
);

export const WrapLeftIcon = () => (
    <Svg>
        <rect x="3" y="7" width="8" height="8" fill="currentColor" stroke="none" rx="1" />
        <path d="M14 8h7M14 12h7M14 16h7M3 20h18" />
    </Svg>
);

export const WrapCenterIcon = () => (
    <Svg>
        <rect x="8" y="8" width="8" height="8" fill="currentColor" stroke="none" rx="1" />
        <path d="M4 4h16M4 20h16" />
    </Svg>
);

export const WrapRightIcon = () => (
    <Svg>
        <rect x="13" y="7" width="8" height="8" fill="currentColor" stroke="none" rx="1" />
        <path d="M3 8h7M3 12h7M3 16h7M3 20h18" />
    </Svg>
);

export const FullWidthIcon = () => (
    <Svg>
        <path d="M4 4h16" />
        <rect x="3" y="8" width="18" height="9" fill="currentColor" stroke="none" rx="1" />
        <path d="M4 21h16" />
    </Svg>
);

export const VideoIcon = () => (
    <Svg>
        <rect x="3" y="5" width="13" height="14" rx="2" />
        <path d="m16 10 5-3v10l-5-3" />
    </Svg>
);

export const AudioIcon = () => (
    <Svg>
        <path d="M4 10v4h3l4 4V6l-4 4H4z" fill="currentColor" stroke="none" />
        <path d="M14.5 9.5a3.5 3.5 0 0 1 0 5" />
        <path d="M17 7a7 7 0 0 1 0 10" />
    </Svg>
);

export const EmbedIcon = () => (
    <Svg>
        <rect x="3" y="4" width="18" height="16" rx="2" />
        <path d="m10 9 5 3-5 3z" fill="currentColor" stroke="none" />
    </Svg>
);
